import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Copy, ExternalLink, Home, Calendar, Hash } from 'lucide-react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { formatOrderNumber } from '../utils/orderNumber';
export function ThankYouPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [orderCopied, setOrderCopied] = useState(false);
  const name = searchParams.get('name') || 'חבר';
  const email = searchParams.get('email') || '';
  const orderNumber = searchParams.get('orderNumber') || '';
  const handleCopyOrderNumber = () => {
    navigator.clipboard.writeText(orderNumber);
    setOrderCopied(true);
    setTimeout(() => setOrderCopied(false), 2000);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white" dir="rtl" data-id="element-2095" data-mp="3msvys6bddqac">
      <Navigation data-id="element-2096" data-mp="3rrqf91lv72ra" />

      <div className="container mx-auto px-4 py-20" data-id="element-2097" data-mp="3rr79ej9ho4tm">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-2098" data-mp="3rpmdap7j0dtn">
          {/* Success Icon */}
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200
        }} className="flex justify-center mb-8" data-id="element-2099" data-mp="9dzl0t7avcvv">
            <div className="bg-green-100 rounded-full p-6" data-id="element-2100" data-mp="jd8ap9v4u5cf">
              <CheckCircle className="w-20 h-20 text-green-600" data-id="element-2101" data-mp="ne0nue74kudz" />
            </div>
          </motion.div>

          {/* Thank You Message */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="text-center mb-12" data-id="element-2102" data-mp="2l4uvuuscf60z">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-2103" data-mp="3shvmhtny4wna">
              תודה {name}! 🎉
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-2104" data-mp="5atknhwqwlyw">
              ההרשמה שלך ל-Water Tribe Fest 2026 התקבלה בהצלחה!
            </p>
            <p className="text-lg text-gray-500 mt-2" data-id="element-2105" data-mp="18ovavdbybi2">
              קיבלת אישור למייל: <span className="font-semibold" data-id="element-2106" data-mp="f8hhcddww3jp">{email}</span>
            </p>
          </motion.div>

          {/* Order Number Card */}
          {orderNumber && <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-white rounded-2xl p-6 md:p-8 shadow-lg border-2 border-indigo-200 mb-8" data-id="element-2107" data-mp="a8237jlt2s0o">
              <div className="flex items-center gap-3 mb-4" data-id="element-2108" data-mp="y0a8s3dc1gpb">
                <div className="bg-indigo-100 rounded-full p-2" data-id="element-2109" data-mp="t160dey8fn01">
                  <Hash className="w-6 h-6 text-indigo-600" data-id="element-2110" data-mp="syt92b6l40ab" />
                </div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-2111" data-mp="1cn8wbn92jqyr">
                  מספר הזמנה
                </h2>
              </div>

              <p className="text-gray-600 mb-4" data-id="element-2112" data-mp="13matv9ea3ria">
                זהו מספר ההזמנה הייחודי שלך. שמור אותו לצורך התכתבות ואימות
                בכניסה לאירוע.
              </p>

              <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-6 border-2 border-indigo-100" data-id="element-2113" data-mp="tvyahki7a4dq">
                <div className="flex items-center justify-between gap-4" data-id="element-2114" data-mp="yn6l2jv9nvsh">
                  <div className="flex-1" data-id="element-2115" data-mp="yohkk7hoihds">
                    <p className="text-sm text-gray-600 mb-2" data-id="element-2116" data-mp="jytmrg8pi0ut">
                      מספר ההזמנה שלך:
                    </p>
                    <p className="text-3xl md:text-4xl font-black text-indigo-600 tracking-wider" data-id="element-2117" data-mp="ox4vfnn9m5bg">
                      {orderNumber}
                    </p>
                  </div>
                  <button onClick={handleCopyOrderNumber} className="bg-indigo-100 hover:bg-indigo-200 p-4 rounded-xl transition-colors shrink-0" data-id="element-2118" data-mp="fuvmv3bk4m0p">
                    {orderCopied ? <CheckCircle className="w-6 h-6 text-indigo-600" data-id="element-2119" data-mp="2wo5u1qhx5d6" /> : <Copy className="w-6 h-6 text-indigo-600" data-id="element-2120" data-mp="2x68ph7nyhu2" />}
                  </button>
                </div>
              </div>
            </motion.div>}

          {/* Billing Announcement */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.55
        }} className="bg-amber-50 rounded-2xl p-6 md:p-8 shadow-lg border-2 border-amber-300 mb-8" data-id="element-2121" data-mp="3q8yt0ui2n7ag">
            <div className="flex items-start gap-4" data-id="element-2122" data-mp="3bd934l9rma0g">
              <div className="bg-amber-200 rounded-full p-3 shrink-0 mt-0.5" data-id="element-2123" data-mp="37am8kclpmazk">
                <span className="text-2xl" data-id="element-2124" data-mp="37cp8ppgktki0">⚠️</span>
              </div>
              <div data-id="element-2125" data-mp="19jjna30gis0u">
                <h3 className="text-xl md:text-2xl font-black text-amber-900 mb-2" data-id="element-2126" data-mp="19k1q5ihmk4hq">
                  שימו לב! ❤️
                </h3>
                <p className="text-lg font-semibold text-amber-800 leading-relaxed" data-id="element-2127" data-mp="2nh4fg0t2kqlh">
                  החיוב יופיע מחברת{' '}
                  <span className="font-black text-amber-950" data-id="element-2128" data-mp="2sf60usdyx204">
                    "אנרצ'י רפואה משלימה"
                  </span>
                  , סכום החיוב יהיה זהה לסכום ההזמנה.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Next Steps */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 mb-8" data-id="element-2129" data-mp="24is54bqf9aob">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-2130" data-mp="2dl1cwtub2py0">מה הלאה?</h3>
            <div className="space-y-4" data-id="element-2131" data-mp="2ij2z3nn135dp">
              <div className="flex items-start gap-4" data-id="element-2132" data-mp="3oy3spmokzbh4">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-2133" data-mp="3oxlrscqz492v">
                  <CheckCircle className="w-5 h-5 text-[#0A5F8F]" data-id="element-2134" data-mp="3tvwwya6bpver" />
                </div>
                <div data-id="element-2135" data-mp="1ttxdqcc9c42k">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-2136" data-mp="1tt45f6xnh6ib">אישור במייל</h4>
                  <p className="text-gray-600" data-id="element-2137" data-mp="1ps25envwsqfa">
                    קיבלת אישור הרשמה למייל עם כל הפרטים החשובים
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-2138" data-mp="1yu1pjp280amg">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-2139" data-mp="1yul3kuor2ev7">
                  <CheckCircle className="w-5 h-5 text-[#0A5F8F]" data-id="element-2140" data-mp="1b4z7wh7l6hry" />
                </div>
                <div data-id="element-2141" data-mp="1665sukcniipo">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-2142" data-mp="166pdi8torl7e">
                    הצטרף לקבוצת הווטסאפ
                  </h4>
                  <p className="text-gray-600 mb-2" data-id="element-2143" data-mp="1kvtw3r4e7rg1">
                    הצטרף לקבוצת הווטסאפ השקטה של הפסטיבל לעדכונים
                  </p>
                  <a href="https://chat.whatsapp.com/BTCYcMWElUsEX6Ds48mQFA" target="_blank" rel="noopener noreferrer" className="text-[#0A5F8F] hover:underline font-semibold inline-flex items-center gap-2" data-id="element-2144" data-mp="scy02pcu3h6e">
                    לחץ כאן להצטרפות
                    <ExternalLink className="w-4 h-4" data-id="element-2145" data-mp="2yzvms8rzu3ab" />
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-2146" data-mp="2q1a9as1dpege">
                <div className="bg-blue-100 rounded-full p-2 shrink-0" data-id="element-2147" data-mp="2q2lemwah2u9m">
                  <Calendar className="w-5 h-5 text-[#0A5F8F]" data-id="element-2148" data-mp="2u23xlmiqgv9t" />
                </div>
                <div data-id="element-2149" data-mp="3hry83xfky7qw">
                  <h4 className="font-bold text-gray-900 mb-1" data-id="element-2150" data-mp="3htj4lslgg0re">סמן ביומן</h4>
                  <p className="text-gray-600" data-id="element-2151" data-mp="3ms2rbv7vhgkt">
                    19-21 בנובמבר 2026 | חוף מעגן עדן, כנרת
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Back to Home Button */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-center" data-id="element-2152" data-mp="3dp1kfsb6nlg3">
            <Button onClick={() => navigate('/water-tribe-fest')} variant="outline" className="inline-flex items-center gap-2" data-id="element-2153" data-mp="22ch9gkhmymgi">
              <Home className="w-5 h-5" data-id="element-2154" data-mp="2szojwk8rvmr7" />
              חזרה לדף הפסטיבל
            </Button>
          </motion.div>
        </motion.div>
      </div>

      <Footer data-id="element-2155" data-mp="2k0b99o8wws4w" />
    </div>;
}